import { render } from "./Tooth.vue?vue&type=template&id=41be8cba"
import script from "./Tooth.vue?vue&type=script&lang=js"
export * from "./Tooth.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__